<template>
    <div class="CampaignDetails" v-if="campaign">
        <v-layout align-center class="header-page">
            <div class="page-title">
                <img
                    :src="campaign.direction ? `/img/${campaign.direction === 'OUTBOUND' ? 'outbound' : 'inbound'}.png` : ''"
                    style="width: 28px; margin-right: 8px"
                    alt="icon-inbound-outbound"
                >
                {{ campaign.title }}
            </div>
            <div class="status-button-group">
                <div class="status-indicator" :style="'background:' + $utils.getStatusColor(campaign.status)">
                    {{ $f.tc(`campaignStatus.${campaign.status.toLowerCase()}`) }}
                </div>
                <v-tooltip top v-if="campaign.status === 'Running'" z-index="100">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" @click="toggleCampaign" color="#96ADD0" size="22">mdi-pause</v-icon>
                    </template>
                    <span>Pause</span>
                </v-tooltip>
                <v-tooltip top v-if="campaign.status === 'Pause'" z-index="100">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" @click="toggleCampaign" color="#96ADD0" size="22">mdi-play</v-icon>
                    </template>
                    <span>Play</span>
                </v-tooltip>
                <v-tooltip top z-index="100">
                    <template v-slot:activator="{ on }">
                        <div class="icon-permission d-flex align-center justify-center" v-on="on" v-if="canAssignRole"
                             @click="openManagePermissionEditor">
                            <img src="/img/permission-grey.svg" alt="icon-permission">
                        </div>
                    </template>
                    <span>Assign roles</span>
                </v-tooltip>
            </div>
            <div v-if="isAdminOrOwner" class="btn-custom" @click="copyToken" style="margin: 0 8px">
                <img src="/img/copy.svg" style="transform: scale(0.95); margin-right: 6px" alt="icon-copy"/>
                {{ $f.tc('copy') }} {{ $f.tc('token') }}
            </div>
            <div
                v-if="showScenario && isAdmin()"
                @click="goToBot"
                class="btn-custom"
            >
                <img
                    src="/img/checkout-bot.svg"
                    style="transform: scale(0.95); margin-right: 6px"
                    alt="icon-checkout-bot"
                />
                {{ $f.tc('bot') }}
            </div>
        </v-layout>
        <v-container fluid grid-list-md class="fci-scrollbar"
                     style="padding: 15px 20px !important; height: calc(100vh - 123px); overflow-y: auto">
            <v-tabs slider-color="primary" class="campaign-detail-tabs" v-model="currentTab">
                <v-tab ripple>{{ $f.tc('overview') }}</v-tab>
                <v-tab ripple v-if="campaign.direction === 'OUTBOUND' && isOutboundCaller">
                    {{ $f.tc('callList') }}
                </v-tab>
                <v-tab ripple>{{ $f.tc('output') }}</v-tab>
                <v-tab ripple v-if="isAdminOrOwner">{{ $t('step.callSetting') }}</v-tab>
                <v-tab ripple v-if="showNewFeature">{{ $f.tc('analytic') }}</v-tab>
                <v-tab ripple v-if="(isAdminOrOwner || isOutboundCaller) && showNewFeature">{{ $f.tc('audit') }}</v-tab>
                <v-tabs-items touchless>
                    <v-tab-item>
                        <CampaignDetailsOverview :campaign="campaign"></CampaignDetailsOverview>
                    </v-tab-item>
                    <v-tab-item v-if="campaign.direction === 'OUTBOUND' && isOutboundCaller">
                        <div class="content-tab">
                            <NewCampaignStep3
                                :is-step="false"
                                :campaign="campaign"
                            ></NewCampaignStep3>
                        </div>
                    </v-tab-item>
                    <v-tab-item>
                        <div class="content-tab display-flex p-0">
                            <div class="p-16" :style="{ width: showHistoryCall ? '70%' : '100%' }">
                                <CampaignDetailsOutput :campaign="campaign"></CampaignDetailsOutput>
                            </div>
                            <CampaignHistoryCall v-if="showHistoryCall"></CampaignHistoryCall>
                        </div>
                    </v-tab-item>
                    <v-tab-item v-if="isAdminOrOwner">
                        <div class="content-tab">
                            <NewCampaignStep4
                                :is-step="false"
                            ></NewCampaignStep4>
                        </div>
                    </v-tab-item>
                    <v-tab-item v-if="showNewFeature">
                        <v-card>
                            <CampaignDetailsAnalytic
                                :campaign="campaign"
                                ref="CampaignDetailsAnalytic"
                            ></CampaignDetailsAnalytic>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item v-if="(isAdminOrOwner || isOutboundCaller) && showNewFeature">
                        <div class="content-tab">
                            <CampaignAudit ref="CampaignAudit"></CampaignAudit>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-container>
        <ManagePermissionEditor ref="ManagePermissionEditor"/>
    </div>
</template>
<script>
import lodash from 'lodash'
import CampaignService from '@/services/campaign.service'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import ManagePermissionEditor from "@/views/Campaign/ManagePermissionEditor";
import CampaignDetailsOverview from "@/views/Campaign/CampaignDetailsOverview";
import CampaignDetailsOutput from "@/views/Campaign/CampaignDetailsOutput";
import CampaignDetailsAnalytic from "@/views/Campaign/CampaignDetailsAnalytic";
import CampaignAudit from "@/views/Campaign/CampaignAudit";
import NewCampaignStep3 from "@/views/Campaign/Form/NewCampaignStep3";
import NewCampaignStep4 from "@/views/Campaign/Form/NewCampaignStep4";
import {mapState} from "vuex";
import CampaignHistoryCall from '@/views/Campaign/CampaignHistoryCall.vue'

let tabListOutbound = ['overview', 'call-list', 'output', 'settings', 'analytic', 'audit']
let tabListInbound = ['overview', 'output', 'settings', 'analytic', 'audit']
const queriesAccept = [
    'direction',
    'tab',
    'time_range',
    'size_most_phone',
    'interval',
    'filter_connected_call',
    'call_id',
    'from',
    'to'
]

export default {
    name: 'CampaignDetails',
    mixins: [FormMixin, RoleMixin],
    components: {
        CampaignHistoryCall,
        NewCampaignStep4,
        NewCampaignStep3,
        CampaignAudit,
        CampaignDetailsAnalytic,
        ManagePermissionEditor,
        CampaignDetailsOverview,
        CampaignDetailsOutput
    },
    data() {
        let tabIndex = this.getCurrentTab()
        tabIndex = tabIndex >= 0 ? tabIndex : 0
        return {
            currentTab: tabIndex,
            campaign: null,
            overviewData: null,
            tableData: [],
            fromDate: '',
            toDate: '',
            dateKey: 1,
            currentPage: 1,
            totalPage: 1,
            itemPerPage: this.$const.itemPerPage,
            totalItems: 0,
            audioName: '',
            audioURL: false,
            audio: false,
            audioExt: false,
            statusList: [
                {text: 'Connected', value: 'connected'},
                {text: 'Unconnected', value: 'unconnected'}
            ],
            fromDateOutPut: '',
            toDateOutput: '',
            statusOutput: '',
            phoneOutput: '',
            viewToken: false,
            showScenario: process.env.NODE_ENV === 'development' || process.env.VUE_APP_ENV === 'demo',
            showNewFeature: false,
            canAssignRole: false,
            tabListInbound,
            tabListOutbound,
            queriesAccept
        }
    },
    computed: {
        ...mapState({
            campaignState: state => state.campaign.campaign,
            isOutboundCaller: () => CampaignService.isOutboundCaller(),
            isAdminOrOwner: () => CampaignService.isAdminOrOwner()
        }),
        showHistoryCall() {
            return this.campaign?.show_history && this.$route.query.call_id && this.$route.query.tab === 'output'
        }
    },
    mounted() {
        let feature = process.env.VUE_APP_NEW_FEATURE
        this.showNewFeature = (feature === 'enable')
        this.getCampaign()
        this.$nextTick(() => {
            this.$store.dispatch(this.$actionTypes.NAVIGATION, false)
        })
    },
    methods: {
        getCurrentTab() {
            let urlTab = this.$route.query.tab
            let direction = this.$route.query.direction
            let tabIndex = -1
            let tabs = direction === 'INBOUND' ? tabListInbound : tabListOutbound
            if (urlTab) {
                tabIndex = tabs.indexOf(urlTab)
            }
            return tabIndex
        },
        openManagePermissionEditor() {
            this.$refs.ManagePermissionEditor.open(this.campaign)
        },
        copyToken() {
            this.viewToken = !this.viewToken
            this.$utils.copyToClipboard(this.campaign.token, 'Copied token to clipboard')
        },
        toggleCampaign() {
            this.$appService.confirm(
                'Do you want to ' + (this.campaign.status === 'Running' ? 'pause' : 'start') + ' this campaign'
            ).then(
                () => CampaignService.changeStatus(
                    this.campaign.id,
                    this.campaign.status === 'Running' ? 'pause' : 'running'
                )
            ).then(
                () => {
                    CampaignService.getCampaign(this.$route.params['campaignId']).then(res => {
                        this.campaign = res.data
                    })
                },
                this.$appService.handleRequestError('Can not change status')
            ).finally(this.$appService.hideLoading)
        },
        goToBot() {
            if (this.campaign.bot) {
                this.$router.push(`/scenarios/${this.campaign.bot.id}`)
            }
        },
        getCampaign() {
            this.$appService.showLoading()
            CampaignService.getCampaign(this.$route.params['campaignId']).then(res => {
                this.$store.dispatch(this.$actionTypes.campaign.SET_DATA, res.data).then(() => {
                    this.campaign = this.$utils.cloneObject(this.campaignState)
                    let query = this.$utils.cloneObject(this.$route.query)
                    if (query.direction !== this.campaign.direction) {
                        query.direction = this.campaign.direction
                        this.$router.replace({
                            query: query
                        })
                    }
                })
            }).finally(this.$appService.hideLoading)
        }
    },
    watch: {
        isOutboundCaller: {
            deep: true,
            handler: function () {
                switch (this.isOutboundCaller) {
                    case false:
                        tabListOutbound = ['overview', 'output', 'analytic']
                        tabListInbound = ['overview', 'output', 'analytic']
                        break
                    case true:
                        switch (this.isAdminOrOwner) {
                            case false:
                                tabListOutbound = ['overview', 'call-list', 'output', 'analytic', 'audit']
                                tabListInbound = ['overview', 'output', 'analytic', 'audit']
                                break
                            case true:
                                tabListOutbound = ['overview', 'call-list', 'output', 'settings', 'analytic', 'audit']
                                tabListInbound = ['overview', 'output', 'settings', 'analytic', 'audit']
                                break
                        }
                        break
                }
                let currentTab = this.getCurrentTab()
                if (currentTab >= 0) {
                    this.currentTab = currentTab
                }
            }
        },
        campaign() {
            setTimeout(this.$forceUpdate, 0)
            this.canAssignRole = RoleMixin.methods.canAssignRoles(this.campaign.permissions)
        },
        currentTab(currentTab) {
            let direction = this.$route.query.direction
            let tabs = direction === 'INBOUND' ? tabListInbound : tabListOutbound
            let query = {
                direction: direction,
                tab: tabs[currentTab]
            }
            this.$router.push({path: `/campaign/${this.$route.params.campaignId}`, query: query})
            let idxAnalytic = tabs.findIndex(i => i === 'analytic')
            if (currentTab === idxAnalytic && this.$refs.CampaignDetailsAnalytic) {
                this.$nextTick(() => {
                    this.$refs.CampaignDetailsAnalytic.reloadDashboard()
                })
            }
        },
        campaignState: {
            deep: true,
            handler: function () {
                this.campaign = this.$utils.cloneObject(this.campaignState)
            }
        },
        '$route.query': {
            deep: true,
            immediate: true,
            handler: function (query) {
                if (!query) return
                // remove query params not accepted
                let queries = Object.keys(query)
                let oldQuery = this.$utils.cloneObject(this.$route.query)
                let newQuery = this.$utils.cloneObject(this.$route.query)
                queries.forEach(queryItem => {
                    if (!this.queriesAccept.includes(queryItem)) {
                        delete newQuery[queryItem]
                    }

                    // validate query param call_id
                    if (['call_id', 'from', 'to'].includes(queryItem) && query.tab !== 'output') {
                        delete newQuery[queryItem]
                    }
                })
                if (!lodash.isEqual(oldQuery, newQuery)) {
                    this.$router.replace({
                        query: newQuery
                    })
                }
            }
        }
    }
}
</script>
<style scoped lang="scss">
.header-page {
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    padding: 0 20px;
    flex-wrap: wrap;
    height: 63px;
}

.page-title {
    color: #12274F;
    font-size: 22px;
    font-family: "open sans bold", serif;
    flex: 1 !important;
    padding: 10px 0;
    display: flex;
    align-items: center;
}

.status-button-group {
    border-radius: 4px;
    border: 1px solid #96ADD0;
    height: 32px;
    display: flex;
    margin-left: 20px;
    overflow: hidden;

    .status-indicator {
        width: 70px;
        height: 100%;
        background: #FFB100;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }

    &::v-deep i {
        width: 32px;
        height: 100%;
        border-left: 1px solid #96ADD0;
        border-right: 1px solid #96ADD0;
        cursor: pointer;

        &:hover {
            background: #d9d9d9;
        }
    }

    .icon-permission {
        width: 32px;
        height: 32px;
        cursor: pointer;

        ::v-deep img {
            transform: scale(0.5);
        }

        &:hover {
            background: #d9d9d9;
        }
    }
}

.campaign-detail-tabs {
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    overflow: hidden;
}

.content-tab {
    padding: 16px;
    background: #fff;
    min-height: calc(100vh - 196px);
}

::v-deep {
    .v-tabs__bar {
        background: #fff !important;
    }

    .v-tabs__item {
        text-transform: none !important;
        font-size: 14px !important;
        letter-spacing: normal !important;
        font-weight: 400 !important;
        margin-right: 0 !important;
        border-right: 1px solid #E4EDFA;
        border-radius: 0 !important;
    }

    .v-tabs__wrapper {
        border-radius: 5px 5px 0 0 !important;
    }

    .v-tabs .v-tabs__bar .v-tabs__item:not(.v-tabs__item--active) {
        color: #12274F;
    }

    .call-to-actions {
        padding-top: 0 !important;
    }

    .config-call {
        margin: 0 !important;
    }

    .config-content {
        height: calc(100vh - 284px) !important;
    }

    .detail-output, .campaign-audit {
        padding: 0 !important;
    }
}
</style>
